
















import {Component, Vue, Prop} from "vue-property-decorator";
import {Link} from "@/link";

@Component({})
export default class AdminNav extends Vue {
    protected links: Link[] = [
        new Link("Calendar", "calendar-alt", "/calendar"),
        new Link("Booking List", "clipboard-list", "/list"),
        new Link("Add Booking", "calendar-plus", "/event", "?eid=new"),
        new Link("Manage Users", "users-cog", "/users"),
        new Link("Settings", "cogs", "/settings"),
    ];
}
